import { DisplayNameSource } from 'graphql/generated/scheme'

interface DisplayNameUser {
	name?: string | null
	displayNameSource?: DisplayNameSource | null
	instagramDisplayName?: string | null
}

export function resolveDisplayName(user?: DisplayNameUser | null): string | null | undefined {
	if (user?.displayNameSource === DisplayNameSource.Instagram && user.instagramDisplayName) {
		return user.instagramDisplayName
	}
	return user?.name
}
